













import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TextLink extends Vue {
  @Prop({ default: "large" }) size!: "small" | "large";
}
